module.exports = __webpack_public_path__ + "static/img/0.0fee05ee.jpg";